module.exports = __webpack_public_path__ + "img/38400.7188ab65.jpg";